<div class="max-w-6xl">
  <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">Tell us about your venue.</h1>
  <p class="mt-3 text-lg text-gray-600">
    This sets your default menu, tax handling and pickup flow. All of it is editable later.
  </p>

  <fieldset class="mt-8">
    <legend class="field-label">Venue Type</legend>
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <button
        *ngFor="let card of cards"
        type="button"
        (click)="onCardSelect(card)"
        class="rounded-lg border p-5 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
        [ngClass]="selectedCardId === card.id
          ? 'border-red-700 bg-red-50 ring-1 ring-red-700'
          : 'border-gray-300 bg-white hover:border-gray-400'"
        [attr.aria-pressed]="selectedCardId === card.id"
      >
        <span class="block font-bold text-gray-900">{{ card.title }}</span>
        <span class="mt-1 block text-sm text-gray-500">{{ card.description }}</span>
      </button>
    </div>

    <div *ngIf="isOtherSelected" class="mt-5 max-w-xl">
      <label for="customVenueType" class="field-label">Describe your venue</label>
      <input
        type="text"
        id="customVenueType"
        class="input-field"
        placeholder="e.g. Community theater snack bar"
        [(ngModel)]="customDescription"
        name="customDescription"
      />
    </div>
  </fieldset>

  <hr class="my-10 border-gray-200" />

  <div class="grid gap-8 lg:grid-cols-2 lg:gap-12">
    <div>
      <p class="field-label" id="nonprofitLabel">Registered 501(c)(3) nonprofit?</p>
      <div class="flex overflow-hidden rounded-lg border border-gray-300" role="group" aria-labelledby="nonprofitLabel">
        <button
          *ngFor="let option of nonprofitOptions; let last = last"
          type="button"
          class="flex-1 px-4 py-3 text-base transition-colors"
          [ngClass]="[
            nonprofitStatus === option.value
              ? 'bg-gray-900 font-bold text-white'
              : 'bg-white font-medium text-gray-700 hover:bg-gray-50',
            last ? '' : 'border-r border-gray-300'
          ]"
          [attr.aria-pressed]="nonprofitStatus === option.value"
          (click)="onNonprofitSelect(option.value)"
        >
          {{ option.label }}
        </button>
      </div>
      <p class="mt-2 text-sm text-gray-500">Unlocks nonprofit pricing. Documentation comes later.</p>
    </div>

    <div>
      <label for="orderVolume" class="field-label">Roughly how many orders a month?</label>
      <select
        id="orderVolume"
        class="input-field"
        [(ngModel)]="monthlyOrderVolume"
        name="monthlyOrderVolume"
      >
        <option value="">Select...</option>
        <option *ngFor="let option of orderVolumeOptions" [value]="option">{{ option }}</option>
      </select>
      <p class="mt-2 text-sm text-gray-500">A rough guess is fine. Helps us recommend a plan.</p>
    </div>
  </div>

  <hr class="my-10 border-gray-200" />

  <div class="flex items-center justify-between gap-4">
    <button
      type="button"
      (click)="onBack()"
      class="inline-flex items-center gap-2 text-base font-medium text-gray-700 hover:text-gray-900"
    >
      <span aria-hidden="true">&larr;</span> Back
    </button>
    <button
      type="button"
      class="btn-brand"
      (click)="onContinue()"
      [disabled]="!isReadyToContinue()"
    >
      Continue
    </button>
  </div>
</div>
